export default __webpack_public_path__ + "img/ba7aee3ed3ef73d0622144c0deb01a22.svg";